import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { FeldUnterkategoriesQueryFilterConfig, IFeldUnterkategoriesQueryShapes } from 'fa-kt.types';
import { FeldUnterkategoriesService } from '../service';

@Component({
  selector: 'fa-kt-feld-unterkategories-filter',
  templateUrl: './feld-unterkategories-filter.component.html',
  styleUrls: ['./feld-unterkategories-filter.component.css'],
})
export class FeldUnterkategoriesFilterComponent {
  readonly subscriptions: Subscription[] = [];

  FeldUnterkategoriesFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public feldUnterkategories: FeldUnterkategoriesService,
  ) {
    this.FeldUnterkategoriesFilterConfig = FeldUnterkategoriesQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.feldUnterkategories.shapes$.subscribe((shapes: IFeldUnterkategoriesQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.FeldUnterkategoriesFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.FeldUnterkategoriesFilterConfig[index].selections = shapes;
  }
}
